import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { buttonFocusStyle } from '../buttons/common.styles';

type PositionProps = {
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
};

type ActionButton = {
  floating: boolean;
  position: PositionProps;
  size: 'medium' | 'large';
};

const getPosition = (coordinates: PositionProps) =>
  // @ts-ignore
  Object.entries(coordinates).reduce((arr, [key, value]) => {
    if (!value) return arr;
    return [
      ...arr,
      css({
        [key]: `${value}px`,
      }),
    ];
  }, []);

export const actionButtonStyles = ({ floating, position, size }: ActionButton) => {
  const diameter = size === 'large' ? '56px' : `40px`;
  return [
    css`
      min-width: ${diameter};
      width: ${diameter};
      height: ${diameter};
      background: ${theme.colors.white};
      border: 1px solid ${theme.colors.neutral20};
      border-radius: 50%;
      color: ${theme.colors.black};
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 250ms ease-out;

      ${buttonFocusStyle({
        focusRingColor: theme.colors.primary50,
        borderRadius: '999px',
      })};

      :focus,
      :hover {
        color: ${theme.colors.black};
      }

      :focus {
        background: ${theme.colors.neutral20};
      }

      :hover:not([disabled]) {
        background: ${theme.colors.neutral20};
      }

      :active {
        color: white;
        background: ${theme.colors.primary50};
        box-shadow: none;
      }

      :disabled {
        color: ${theme.colors.neutral20};
        background: ${theme.colors.neutral5};
        cursor: default;
      }
    `,
    ...(floating
      ? [
          css`
            box-shadow: ${theme.shadows.heavy};
            position: absolute;
            background: ${theme.colors.primary50};
            color: white;
          `,
          ...getPosition(position),
          css`
            :focus,
            :hover {
              color: ${theme.colors.white};
            }

            :focus {
              background: ${theme.colors.primary50};
            }

            :hover {
              background: ${theme.colors.primary70};
            }

            :active {
              background: ${theme.colors.primary80};
            }

            :disabled {
              color: ${theme.colors.neutral20};
              background: ${theme.colors.neutral5};
              cursor: default;
            }
          `,
        ]
      : []),
  ];
};
